import Box from '@material-ui/core/Box'
import { useTheme } from '@material-ui/styles'
import {
  StoryblokComponent,
  useStoryblokEditable
} from '@sb-konzept/gatsby-source-storyblok'
import Image from 'gatsby-image'
import * as R from 'ramda'
import React, { useMemo } from 'react'
import styled from 'styled-components'

const Background = styled.div`
  > * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: ${(props) => props.backgroundColor || 'transparent'};
  }
`
Box.Background = Background

function StoryblokContainer(props) {
  const { content } = props
  const { editableProps } = useStoryblokEditable()
  const theme = useTheme()

  const {
    body,
    backgroundImage,
    backgroundImageAltText,
    backgroundColor,
    textAlign,
    maxWidth,
    marginX,
    paddingX,
    marginY,
    paddingY,
    flex,
    centerContent,
    shadow,
    anchor
  } = content

  const mergeProps = R.compose(
    R.reduce(R.mergeDeepRight, {}),
    R.reject(R.not)
  )

  const computedProps = useMemo(
    () => mergeProps([{ position: 'relative' }, textAlign && { textAlign }]),
    [mergeProps, textAlign]
  )

  return (
    <Box
      {...computedProps}
      {...editableProps}
      alignItems="center"
      bgcolor={backgroundColor || 'transparent'}
      boxShadow={shadow ? 4 : null}
      display={centerContent ? 'flex' : 'block'}
      flex={flex || 1}
      id={anchor || null}
      justifyContent="center"
      maxWidth={`${maxWidth}%` || 'auto'}
      mx={maxWidth && 'auto'}
      my={marginY * 1.5 || 0}
      position="relative"
      px={`${paddingX}%` || 'auto'}
      py={paddingY * 1.5 || 0}
    >
      {backgroundImage.localFile && (
        <Box.Background backgroundColor={backgroundColor}>
          {backgroundImage.localFile.childImageSharp ? (
            <Image
              alt={backgroundImageAltText || 'image'}
              fluid={backgroundImage.localFile.childImageSharp.fluid}
              style={{ position: false }}
            />
          ) : (
            <img
              alt={backgroundImageAltText || 'image'}
              src={backgroundImage.localFile.publicURL}
            />
          )}
        </Box.Background>
      )}
      {body?.map((b) => (
        <StoryblokComponent key={b.id || b._uid} content={b} />
      ))}
    </Box>
  )
}

export default StoryblokContainer
